import React from "react"
import "../components/index.css"

import SkySplash from "../components/sky-splash"

const IndexPage = ({ location }) => <SkySplash location={location} />

export default IndexPage
